var modules_783e1af8 = {"container":"_1cgfv05","icon":"_1xadfpv"};
import "../../../assets/6J0sUYJu.css";

export { modules_783e1af8 as default };
//# sourceMappingURL=ExpandCell.module.less.js.map
